import {useSelector} from "react-redux";
import './index.css'
import ReportResultLayout from "@/pages/Report/ReportResultLayout";
import ReportSummaryCard from "@/pages/Report/ReportSummaryCard";
import {RootState} from "@/store";
import IncomeStatementTable from "@/pages/Report/IncomeStatementTable";

interface IncomeStatementResultProps {
  handlePageChange: (page: number) => void
}
const IncomeStatementResult = ({handlePageChange}: IncomeStatementResultProps) => {
  const summary = useSelector((state: RootState) => state.incomeStatement.state.summary)
  
  return (
    <>
      {
        summary && <ReportResultLayout
          useHeaderVenue
          useHeaderDate
          reportType='INCOME_STATEMENT'
					selectedInsightType='INCOME_STATEMENT'>
          {
            summary && <div className="j-col">
              <div className="j-col gap-4">
                <div className="text-jlg">Summary</div>
                <div className="grid grid-cols-3 gap-7">
                  <ReportSummaryCard
                    title="Total Net Income"
                    total={summary.total_net_income}
                    classNames="border-b-black bg-blue-light text-white border-b-blue-dark border-b-[6px]"/>
                  <ReportSummaryCard
                    title="Total Gross Income"
                    total={summary.total_gross_income}
                    classNames="border-b-green-success border-b-[6px]"/>
                  <ReportSummaryCard
                    title="Total Refund"
                    total={summary.total_refund}
                    classNames="border-b-red-secondary border-b-[6px]"/>
                </div>
              </div>
              <div className="horizontal-separator my-6"/>
              <IncomeStatementTable 
                handlePageChange={handlePageChange}
              />
            </div>
          }
        </ReportResultLayout>
      }
    </>
  )
  
}
export default IncomeStatementResult;